import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationEaseOut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAnimationEaseOut"><Path fillRule="evenodd" clipRule="evenodd" d="M21.1424 4.3239L20.4095 4.48299C15.8385 5.47514 12.3637 7.21038 9.78721 9.78684C7.21074 12.3633 5.4755 15.8381 4.48335 20.4091L4.32427 21.1421L2.8584 20.8239L3.01748 20.091C4.05355 15.3176 5.89615 11.5566 8.72655 8.72618C11.5569 5.89578 15.318 4.05318 20.0913 3.01712L20.8243 2.85803L21.1424 4.3239Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAnimationEaseOut;
